// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__1QD5K","mobileMenu":"Footer_mobileMenu__nn4w2","footerLogo":"Footer_footerLogo__1FC_A","footerContainer":"Footer_footerContainer__cKcLx"};